export default {
  fill: 'CROPS_ACTIONS_FILLCROPS',
  filter: 'CROPS_ACTIONS_FILTERCROPS'
}
